module.exports = __webpack_public_path__ + "HRA Brochure - year end grace.pdf";